/* eslint-disable */
import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
  Title,
} from "chart.js";
import { Chart } from "react-chartjs-2";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

const StackedBarLine = ({ datasets, chartData, indexAxis, height, width="100%"}) => {
  const data = {
    labels: chartData.map((item) => item.month),
    datasets: datasets
  };

  const options = {
    indexAxis: indexAxis,
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 10  // <-- Change legend font size here
          },
        },

        // onClick(e) {
        //   if (e.stopPropagation) e.stopPropagation();
        // },
        position: "top",
      },
      datalabels: {
        color: "white",
        anchor: "center",
        align: "center",
        // display: "auto",
        // clip: "auto",
        font: {
          weight: "bold",
          size: 10,
        },
      },
      tooltip: {
        intersect: false,
      },    
    },
    scales: {
      x: {
        stacked: true,
        display: true,
        fontWeight: "bold",
        ticks: {
          display: true,
        },
        grid: {
          display: false,
        },
      },
      y: {
        stacked: "normalized",
        display: true,
        fontWeight: "bold",
        ticks: {
          display: true, // hide the numbers on the y-axis
        },
        grid: {
          display: false,
        },
      },
    },
  };

  const option = options
  
  return (
    <div className="w-full p-2 bg-white rounded-xl"  style={{ height: `${height}px`, width: `${width}%` }}>
      <Chart data={data} options={option} />
    </div>
  );
};

export default StackedBarLine;